import { render, staticRenderFns } from "./bbs-information.vue?vue&type=template&id=3971337f&scoped=true"
import script from "./bbs-information.vue?vue&type=script&lang=ts"
export * from "./bbs-information.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3971337f",
  null
  
)

export default component.exports